
















































































































































































































































































































































import { Component } from 'vue-mixin-decorator';
import moment from 'moment';
import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import BirthdaySelect from '@/components/BirthdaySelect.vue';
import PrefectureSelect from '@/components/PrefectureSelect.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';

import * as RouterPath from '@/classification/RouterPath';

import * as Msgs from '@/common/Messages';
import * as StringUtil from '@/common/StringUtil';
import * as JwtUtil from '@/common/JwtUtil';

import RepositoryFactory from '@/repository/RepositoryFactory';

import ExamInfo from '@/models/exam/ExamInfo';
import ExamineeAttribute from '@/models/account/ExamineeAttribute';
import ExamineeItem from '@/models/examinee/ExamineeItem';
import UpdateUserInfo from '@/models/account/UpdateUserInfo';

import { Core as YubinBangoCore } from 'yubinbango-core';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'e-confirm-modal': ConfirmModal,
      'e-indicator': IndicatorModal,
      'birthday-select': BirthdaySelect,
      'prefecture-select': PrefectureSelect,
    },
  },
)
export default class UpdateInfo extends BaseView {
  private isConfirmModalDisplay = false;

  private modalTitle = '更新確認';

  private modalText = '更新してもよろしいですか？';

  private okButtonLabel = '更新する';

  private cancelButtonLabel = 'キャンセル';

  private isIndicatorDisplay = false;

  private routerPath = RouterPath;

  private AccountRepository = RepositoryFactory.get().account;

  private ExamRepository = RepositoryFactory.get().exam;

  private ExamineeRepository = RepositoryFactory.get().examinee;

  private updateUserInfo = new UpdateUserInfo();

  private examInfo = new ExamInfo();

  private examineeItems: ExamineeItem[] = [];

  private errMsg = {
    gender: '',
    birthday: '',
    postalCode: '',
    prefecture: '',
    city: '',
    street: '',
    buildingName: '',
    phoneNumber: '',
  };

  private async mounted() {
    this.isIndicatorDisplay = true;

    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const AccountCommonCss = document.createElement('link');
    AccountCommonCss.rel = 'stylesheet';
    AccountCommonCss.href = '/account/css/common.css';
    this.$el.appendChild(AccountCommonCss);

    const EntryCss = document.createElement('link');
    EntryCss.rel = 'stylesheet';
    EntryCss.href = '/account/css/entry.css';
    this.$el.appendChild(EntryCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    // 各種情報取得
    await this.getAccount();
    await this.getExam();
    await this.getOptionItems();

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);

    this.isIndicatorDisplay = false;
  }

  /**
   * 受験者情報取得
   */
  async getAccount() {
    try {
      await this.AccountRepository.getAccount()
        .then((response) => {
          try {
            this.updateUserInfo = this.AccountRepository.convert.deserialize(response.data, UpdateUserInfo) as UpdateUserInfo;
          } catch {
            throw Error(Msgs.INVALID_RESPONSE);
          }
        })
        .catch(() => {
          JwtUtil.deleteJwt();
          this.$router.replace(this.paths.LOGIN);
        });
    } catch (_) {
      JwtUtil.deleteJwt();
      this.$router.replace(this.paths.LOGIN);
    }
  }

  /**
   * 検定情報取得
   */
  async getExam() {
    try {
      await this.ExamRepository.getExam()
        .then((response) => {
          this.examInfo.examTitle = response.data.exam_title;
          this.examInfo.useNameFlg = response.data.use_name_flg;
          this.examInfo.useGenderFlg = response.data.use_gender_flg;
          this.examInfo.useAddressFlg = response.data.use_address_flg;
          this.examInfo.useMailAnnounceFlg = response.data.use_mail_announce_flg;
        })
        .catch(() => {
          this.$router.replace(this.paths.TOP);
        });
    } catch (_) {
      this.$router.replace(this.paths.TOP);
    }
  }

  /**
   * オプション項目取得
   */
  async getOptionItems() {
    try {
      await this.ExamineeRepository.getExamineeItems().then((response) => {
        if (response.status === 200) {
          const items = response.data.option_items;
          items.forEach((object: any) => {
            const item = new ExamineeItem();
            object.choices.forEach((choice: any) => {
              item.choices.push({
                displayName: choice.display_name,
                value: choice.value,
              });
            });
            item.optionItemCode = object.option_item_code;
            item.optionItemTitle = object.option_item_title;
            item.inputType = object.input_type;
            item.isRequired = object.is_required;
            item.format = object.format;

            this.updateUserInfo.examineeAttributes.forEach((attribute: any) => {
              if (attribute.option_item_code === object.option_item_code) {
                if (object.input_type === 'checkbox') {
                  item.values = StringUtil.isEmpty(attribute.input_text) ? [] : attribute.input_text.split(',');
                } else if (object.input_type === 'combo') {
                  object.choices.forEach((choice: any) => {
                    if (choice.value === attribute.input_text) {
                      item.value = choice.display_name;
                    }
                  });
                } else {
                  item.value = attribute.input_text;
                }
              }
            });
            this.examineeItems.push(item);
          });
        }
      }).catch(() => {
        this.$router.replace(this.paths.TOP);
      });
    } catch (_) {
      this.$router.replace(this.paths.TOP);
    }
  }

  /**
   * 生年月日（年）を設定します。
   * BirthdaySelectのEmitとして呼ばれます。
   *
   * @param year yyyyの文字列
   */
  private setBirthYear(year: string) {
    this.updateUserInfo.birthYear = year;
  }

  /**
   * 生年月日（月）を設定します。
   * BirthdaySelectのEmitとして呼ばれます。
   *
   * @param month MMの文字列
   */
  private setBirthMonth(month: string) {
    this.updateUserInfo.birthMonth = month;
  }

  /**
   * 生年月日（日）を設定します。
   * BirthdaySelectのEmitとして呼ばれます。
   *
   * @param date ddの文字列
   */
  private setBirthDate(date: string) {
    this.updateUserInfo.birthDate = date;
  }

  /**
   * 都道府県を設定します。
   * PrefectureSelectのEmitとして呼ばれます。
   *
   * @param prefecture 都道府県名
   */
  private setPrefecture(prefecture: string) {
    this.updateUserInfo.prefecture = prefecture;
  }

  /**
   * 郵便番号から住所を取得します。
   */
  getAddressFromPostalCode() {
    const { postalCode } = this.updateUserInfo;
    if (StringUtil.isEmpty(postalCode)) return;

    this.updateUserInfo.prefecture = '';
    this.updateUserInfo.city = '';
    this.updateUserInfo.street = '';
    this.updateUserInfo.buildingName = '';

    if (!StringUtil.isEmpty(postalCode)) {
      // eslint-disable-next-line no-new
      new YubinBangoCore(String(postalCode), (addr: any) => {
        this.updateUserInfo.prefecture = addr.region;
        this.updateUserInfo.city = addr.locality;
        this.updateUserInfo.street = addr.street;
      });
    }
  }

  /**
   * 受験者情報更新
   */
  async update() {
    this.isConfirmModalDisplay = false;
    this.isIndicatorDisplay = true;

    if (!this.examInfo.useGenderFlg) {
      this.updateUserInfo.gender = null;
    }

    if (!this.examInfo.useAddressFlg) {
      this.updateUserInfo.postalCode = null;
      this.updateUserInfo.prefecture = null;
      this.updateUserInfo.city = null;
      this.updateUserInfo.street = null;
      this.updateUserInfo.buildingName = null;
      this.updateUserInfo.phoneNumber01 = null;
      this.updateUserInfo.phoneNumber02 = null;
      this.updateUserInfo.phoneNumber03 = null;
    }

    if (!this.examInfo.useMailAnnounceFlg) {
      this.updateUserInfo.isReceiveMailAnnounce = null;
    }

    const examineeAttributes: ExamineeAttribute[] = [];
    Object.keys(this.examineeItems).forEach((key: any) => {
      const item = this.examineeItems[key];
      const attribute = new ExamineeAttribute();
      attribute.optionItemCode = item.optionItemCode;
      if (item.inputType === 'checkbox') {
        attribute.inputText = item.values.length === 0 ? '' : item.values.join(',');
      } else if (item.inputType === 'combo') {
        attribute.inputText = '';
        item.choices.forEach((choice: any) => {
          if (choice.displayName === item.value.trim()) {
            attribute.inputText = choice.value;
          }
        });
      } else {
        attribute.inputText = StringUtil.isEmpty(item.value) ? '' : item.value;
      }
      examineeAttributes.push(this.AccountRepository.convert.serialize(attribute));
    });
    this.updateUserInfo.examineeAttributes = examineeAttributes;

    try {
      await this.AccountRepository.updateAccount(this.updateUserInfo)
        .then((response) => {
          try {
            this.$router.replace(RouterPath.UPDATE_INFO_COMPLETE);
          } catch {
            throw Error(Msgs.INVALID_RESPONSE);
          }
        })
        .catch((err: any) => {
          if (err.response.status === 400) {
            try {
              const errorObj = JSON.parse(err.response.data.error);
              this.setExamineeItemValidateMessage(errorObj);
            } catch {
              this.$router.replace(this.paths.TOP);
            }
          } else {
            this.$router.replace(this.paths.TOP);
          }
        });
    } catch (_) {
      this.$router.replace(this.paths.TOP);
    } finally {
      this.isIndicatorDisplay = false;
    }
  }

  /**
   * 入力タイプが選択型か判定します。
   *
   * @param inputType 入力タイプ
   */
  static isSelectType(inputType: string) {
    return (inputType === 'checkbox' || inputType === 'radio' || inputType === 'combo');
  }

  /**
   * 入力された項目が更新可能か判定し、更新可能な場合、確認ダイアログを表示します。
   */
  private validate() {
    // ボタン外でモーダル非表示になった時のためにfalse
    this.isConfirmModalDisplay = false;

    this.resetErrorMessage();
    this.validateDefaultItems();
    this.validateOptionItems();
    if (Object.values(this.errMsg).every((val) => StringUtil.isEmpty(val))
      && Object.values(this.examineeItems).every((item) => !item.isValidateFail)) {
      // エラーなしのため、確認モーダルの表示
      this.isConfirmModalDisplay = true;
    }
  }

  /**
   * エラーメッセージをリセットします。
   */
  private resetErrorMessage() {
    this.errMsg = {
      gender: '',
      birthday: '',
      postalCode: '',
      prefecture: '',
      city: '',
      street: '',
      buildingName: '',
      phoneNumber: '',
    };
  }

  /**
   * 通常項目のValidateを行います。
   */
  private validateDefaultItems() {
    this.validateGender();
    this.validateBirthday();
    this.validateAddress();
    this.validatePhoneNumber();

    let isValidateError = false;
    Object.entries(this.errMsg).forEach(([key, value]) => { // eslint-disable-line
      if (!isValidateError) {
        isValidateError = value !== '';
      }
    });
  }

  /**
   * オプション項目のValidateを行います。
   */
  private validateOptionItems() {
    this.examineeItems.forEach((item, index, array) => {
      item.setIsValidateFail(false);
      item.setValidateMessage('');
      if (item.isRequired) {
        if (item.inputType === 'checkbox') {
          item.setIsValidateFail(item.values.length === 0);
        } else {
          item.setIsValidateFail(StringUtil.isEmpty(item.value));
        }

        if (item.isValidateFail) {
          if (UpdateInfo.isSelectType(String(item.inputType))) {
            item.setValidateMessage(`${item.optionItemTitle}${Msgs.TEMPLATE_REQUIRED_SELECT}`);
          } else {
            item.setValidateMessage(`${item.optionItemTitle}${Msgs.TEMPLATE_REQUIRED_INPUT}`);
          }
          return;
        }
      }

      // 入力形式の場合文字数チェック
      if (item.inputType === 'text' || item.inputType === 'area') {
        if (!StringUtil.isEmpty(item.value) && item.value.length > 500) {
          item.setIsValidateFail(true);
          item.setValidateMessage(Msgs.generateLengthMessage(String(item.optionItemTitle), '500文字以下'));
        }
      }
    });
  }

  /**
   * パスワードのValidateを行います。
   */
  private validateGender() {
    if (!this.examInfo.useGenderFlg) return;

    if (StringUtil.isEmpty(this.updateUserInfo.gender)) {
      this.errMsg.gender = Msgs.REQUIRED_GENDER;
    }
  }

  /**
   * 生年月日のValidateを行います。
   */
  private validateBirthday() {
    if (StringUtil.isEmpty(this.updateUserInfo.birthYear)
      || StringUtil.isEmpty(this.updateUserInfo.birthMonth)
      || StringUtil.isEmpty(this.updateUserInfo.birthDate)) {
      this.errMsg.birthday = Msgs.REQUIRED_BIRTHDAY;
      return;
    }

    // 存在日チェック
    const info = this.updateUserInfo as any;
    const y = info.birthYear as string;
    const m = info.birthMonth as string;
    const d = info.birthDate as string;
    const birthday = `${y}-${m}-${d}`;
    if (!moment(birthday, 'YYYY-MM-DD').isValid()) {
      this.errMsg.birthday = Msgs.INVALID_BIRTHDAY;
    }
  }

  /**
   * 住所と電話番号のValidateを行います。
   */
  private validateAddress() {
    if (!this.examInfo.useAddressFlg) return;

    if (StringUtil.isEmpty(this.updateUserInfo.postalCode)) {
      this.errMsg.postalCode = Msgs.REQUIRED_POSTAL_CODE;
    } else {
      const postalCode = String(this.updateUserInfo.postalCode);
      const isNumeric = postalCode.match('[^0-9]') === null;
      if (!isNumeric) {
        this.errMsg.postalCode = Msgs.POSTAL_CODE_STRING_TYPE;
      } else if (postalCode.length > 7) {
        this.errMsg.postalCode = Msgs.POSTAL_CODE_LENGTH;
      }
    }

    if (StringUtil.isEmpty(this.updateUserInfo.prefecture)) {
      this.errMsg.prefecture = Msgs.REQUIRED_PREFECTURE;
    } else {
      const prefecture = String(this.updateUserInfo.prefecture);
      if (prefecture.length > 4) {
        this.errMsg.prefecture = Msgs.PREFECTURE_LENGTH;
      }
    }

    if (StringUtil.isEmpty(this.updateUserInfo.city)) {
      this.errMsg.city = Msgs.REQUIRED_CITY;
    } else {
      const city = String(this.updateUserInfo.city);
      if (city.length > 255) {
        this.errMsg.city = Msgs.CITY_LENGTH;
      }
    }

    if (StringUtil.isEmpty(this.updateUserInfo.street)) {
      this.errMsg.street = Msgs.REQUIRED_STREET;
    } else {
      const street = String(this.updateUserInfo.street);
      if (street.length > 255) {
        this.errMsg.street = Msgs.STREET_LENGTH;
      }
    }

    const buildingName = String(this.updateUserInfo.buildingName);
    if (buildingName.length > 255) {
      this.errMsg.buildingName = Msgs.BUILDING_NAME_LENGTH;
    }
  }

  /**
   * 電話番号のValidateを行います。
   */
  private validatePhoneNumber() {
    if (!this.examInfo.useAddressFlg) return;

    if (StringUtil.isEmpty(this.updateUserInfo.phoneNumber01)
    || StringUtil.isEmpty(this.updateUserInfo.phoneNumber02)
    || StringUtil.isEmpty(this.updateUserInfo.phoneNumber03)) {
      this.errMsg.phoneNumber = Msgs.REQUIRED_PHONE_NUMBER;
      return;
    }

    const phone01 = String(this.updateUserInfo.phoneNumber01);
    const phone02 = String(this.updateUserInfo.phoneNumber02);
    const phone03 = String(this.updateUserInfo.phoneNumber03);
    const concatPhoneNumber = `${phone01}${phone02}${phone03}`;

    const isNumeric = concatPhoneNumber.match('[^0-9]') === null;
    if (!isNumeric) {
      this.errMsg.phoneNumber = Msgs.PHONE_NUMBER_STRING_TYPE;
      return;
    }

    if (phone01.length > 4 || phone02.length > 4 || phone03.length > 4) {
      this.errMsg.phoneNumber = Msgs.PHONE_NUMBER_LENGTH;
    }
  }

  /**
   * 確認モーダルのOKボタン押下時の処理
   */
  private modalOkButtonClick() {
    this.update();
  }

  /**
   * 確認モーダルのキャンセルボタン押下時の処理
   */
  private modalCancelButtonClick() {
    this.isConfirmModalDisplay = false;
  }

  setExamineeItemValidateMessage(errorObj: any) {
    errorObj.forEach((err: any) => {
      const examineeItem = this.examineeItems.find((v) => v.optionItemCode === err.option_item_code);
      if (examineeItem === undefined) {
        return;
      }
      examineeItem.setIsValidateFail(true);
      if (!StringUtil.isEmpty(err.error_message)) {
        examineeItem.setValidateMessage(err.error_message);
      }
    });
  }
}
